import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { buildClassNames } from '../../style/build-class-names';
import './dial-code-preview.module.css';
export interface DialCodePreviewStyleProps {
  style?: React.CSSProperties;
  className?: string;
}
export interface DialCodePreviewProps extends DialCodePreviewStyleProps {
  dialCode: string;
  prefix: string;
  disabled?: boolean;
}
export const DialCodePreview: React.FC<DialCodePreviewProps> = t0 => {
  const $ = _c(7);
  const {
    dialCode,
    prefix,
    disabled,
    style,
    className
  } = t0;
  const t1 = disabled && "dial-code-preview--disabled";
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = buildClassNames({
      addPrefix: ["dial-code-preview", t1],
      rawClassNames: [className]
    });
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `${prefix}${dialCode}`;
  let t4;
  if ($[3] !== style || $[4] !== t2 || $[5] !== t3) {
    t4 = <div className={t2} style={style}>{t3}</div>;
    $[3] = style;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};